import { ReactNode, KeyboardEvent } from "react";

import { useAnalyticsEvents } from "@atlaskit/analytics-next";

export interface TryIntentProps {
    children: ReactNode;
    intentType: "button" | "form" | "demo";
    containerId?: string;
    productKey?: string;
}

export const TryIntent = ({
    children,
    intentType,
    containerId,
    productKey
}: TryIntentProps) => {
    const { createAnalyticsEvent } = useAnalyticsEvents();
    const onTryIntentClick = () => {
        createAnalyticsEvent({
            eventType: "track",
            action: "interacted",
            actionSubject: "tryIntentComponent",
            containerId: containerId,
            actionSubjectId: intentType,
            attributes: {
                productKey: productKey
            }
        }).fire();
    };
    const onKeyDown = (e: KeyboardEvent) => {
        if (e.code !== "Tab" && e.code !== "Enter" && e.code !== "Space") {
            createAnalyticsEvent({
                eventType: "track",
                action: "interacted",
                actionSubject: "tryIntentComponent",
                containerId: containerId,
                actionSubjectId: intentType,
                attributes: {
                    productKey: productKey
                }
            }).fire();
        }
    };

    return (
        <div
            data-testid={"try-intent-wrapper"}
            onKeyDown={onKeyDown}
            onClick={onTryIntentClick}
        >
            {children}
        </div>
    );
};

export default TryIntent;
